import { handleTrack } from '../../../utils/tracker';
import { SelectInput } from '../../Calculators/calculator-revamp/components/form-components/SelectBox';
import { AtcBasicDetailsData } from '../Atc-calculator-constants';
import { CALCULATOR_TAB_PROPS } from '../types';

const AtcBasicDetails = ({
  setInputData,
  inputTabData,
}: CALCULATOR_TAB_PROPS) => {
  const handleChange = (key: string, value: number | string) => {
    handleTrack({ label: `ATC_Basic_details_${key}` });
    setInputData?.((prev) => ({ ...prev, [key]: value }));
  };
  return (
    <div className="grid grid-cols-2 grid-rows-2 gap-x-12 gap-y-6 sm:grid-cols-1 sm:gap-2 font-medium sm:text-base">
      {AtcBasicDetailsData.map((props, index) => (
        <SelectInput
          key={index}
          {...props}
          onChange={handleChange}
          value={`${inputTabData?.[props.id]}`}
        />
      ))}
    </div>
  );
};

export default AtcBasicDetails;
